/* eslint-disable react/jsx-indent */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
/* eslint-disable indent */
/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import {
  Text,
  LoadingDot,
  Table,
  Button,
  Icon,
  Clamp,
} from 'components/atoms';
import { Tooltip, PopoverActions, ModalConfirm } from 'components/molecules'
import { injectIntl, FormattedMessage } from 'react-intl'
import { intlType } from 'types'
import { filesize } from 'filesize'
import { generateReadablePtDate } from 'services/generators'
import { PORTAL_WWW } from 'services/constants'
import { deleteFiles } from 'services/requests'
import { useCopyToClipboard } from 'react-use'
import { Toast } from 'containers';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom'
import { useMutation } from 'react-query'

let manageIcon = [];

const FileTable = memo(({
  files,
  loading,
  intl,
  noDataText,
  onSelect,
  icon,
  subweb,
  lang,
  filemodule,
  onClickAdd,
  refetchData,
  rteofile,
  teste
}) => {
  const history = useHistory()
  const [, copyToClipboard] = useCopyToClipboard()
  const [confirmation, setConfirmation] = useState({
    isConfirmed: false,
    selectedFile: null,
  })
  const [iconbutton, setIcon] = useState(false);

  const [deleteFile] = useMutation(deleteFiles, {
    onSuccess: () => {
      toast.success(
        <Toast
          type="success"
          title="Ficheiro apagado"
          description="O ficheiro foi apagado com sucesso."
        />
      )
    },
    onError: (err) => {
      toast.error(
        <Toast
          type="error"
          title="Erro a apagar o ficheiro"
          description={err.message}
        />
      )
    }
  });

  const filesComputed = React.useMemo(() => {
    if (
      files && files.data && files.data.data
      && files.data.data.length > 0
    ) {
     if (!filemodule) {
        const memfiles = JSON.parse(window.sessionStorage.getItem('initialValues'))
        
        // eslint-disable-next-line no-plusplus
        for (let i = memfiles.data.length - 1; i >= 0; i--) {
          const auxObj = memfiles.data[i]
          const index = files.data.data.map(e => e.id).indexOf(memfiles.data[i].id);
          auxObj.check = true;
          auxObj.currentCheck = true
          auxObj.dateUpdate = auxObj.date;
          auxObj.title = auxObj.name
          if (index > -1) {
            files.data.data.splice(index, 1)
            files.data.data.unshift(auxObj)
          }
        }
      }
      return files.data.data.map(({
        id,
        title,
        editable,
        orginalName,
        size,
        dateUpdate,
        description,
        check,
        type,
        currentCheck,
        numberDownloads,
        lastDownload
      }) => ({
        check: !!check,
        currentCheck: !!currentCheck,
        id,
        title,
        editable,
        // eslint-disable-next-line no-nested-ternary
        type: !check ? (orginalName.split('.').length === 2 ? orginalName.split('.')[1] : null) : type,
        size: !check ? filesize(size) : size,
        // type: orginalName.split('.').length === 2 ? orginalName.split('.')[1] : null,
        // size: filesize(size),
        date: !check ? generateReadablePtDate(dateUpdate) : dateUpdate,
        description,
        // type: orginalName.split('.').length === 2 ? orginalName.split('.')[1] : null,
        // size: filesize(size),
        // date: generateReadablePtDate(dateUpdate),
        numberDownloads,
        lastDownload
      }))
    }
    return []
  }, [files])
  

  const handleCopyToClipboard = (file) => {
    const { id, title } = file
    copyToClipboard(`${PORTAL_WWW}/file/${id}`)
    toast.success(
      <Toast
        type="success"
        title="Link do ficheiro copiado"
        description={`Ficheiro: ${title}`}
      />
    );
  }

  const handleDownload = (file) => {
    const { id, title } = file
    window.location.assign(`${PORTAL_WWW}/file/${id}`);
    toast.success(
      <Toast
        type="success"
        title="Download iniciado"
        description={`Ficheiro: ${title}`}
      />
    );
  }

  const handleEditFile = (file) => {
    const { id } = file
    history.push(`/${encodeURIComponent(subweb)}/files/${lang}/${id}`)
  }

  const handleSelect = (e, original) => {
    e.preventDefault()
    e.stopPropagation();
    onSelect(
      files && files.data && files.data.data
        ? files.data.data.find(file => file.id === original.id)
        : null
    )
  }

  const handleFileSelect = (e, value) => {
    let aux = null;
    
        // eslint-disable-next-line no-param-reassign
    if (!value.check && !value.currentCheck) {
      value.check = true;
      // value.currentCheck = true
      onClickAdd(value);
    }
    else if (value.check && !value.currentCheck) {
      value.check = false;
      // value.currentCheck = true
      onClickAdd(value);
    }
    
    if (aux == null) {
      manageIcon.push(value.id)
      setIcon((prev) => !prev);
    } else {
      delete manageIcon[aux]
    }
  }
  const handleFileUrl = (rec) => {
    teste(rec);
  }

  const isDisable = (file) => {
    const { editable } = file
    return !editable
  }

  const handleDeleteFile = (hasConfirmed) => {
    const { id } = confirmation.selectedFile

    if (hasConfirmed) {
      deleteFile({ fileId: id, subweb })
      refetchData()
    }
    setConfirmation({ ...confirmation, isConfirmed: false })
  }

  let ic = false;
  return (
    <>
      <ModalConfirm
        isOpen={confirmation.isConfirmed}
        toggle={() => setConfirmation({ ...confirmation, isConfirmed: !confirmation.isConfirmed })}
        onChange={handleDeleteFile}
        title="Apagar ficheiro"
        message="Depois de apagado, o ficheiro deixará de estar disponível de forma permanente. Tem a certeza a certeza que pretende continuar?"
        textConfirm="Sim"
        textDiscard="Cancelar"
      />
      <Table
        data={filesComputed}
        columns={[
          ...(
            icon && filemodule && rteofile
              ? [{
                Header: '',
                accessor: 'icon',
                resizable: false,
                width: 60,
                Cell: ({ original }) => (
                  <Tooltip tooltip="copiar link do ficheiro" placement="top">
                    <CellStart>
                      <Button modifiers={['small', 'primaryHover']} onClick={(e) => handleSelect(e, original)}>
                        <Icon icon={icon} height={16} />
                      </Button>
                    </CellStart>
                  </Tooltip>
                ),
              }]
              : []
          ),
          ...(
            (!filemodule)
              ? [{
                Header: '',
                accessor: 'icon',
                resizable: false,
                width: 60,
                Cell: ({ original }) => (
                  <Tooltip tooltip="selecionar ficheiro" placement="top">
                    <CellStart>
                      <Button modifiers={['small', 'primaryHover']} onClick={(e) => handleFileSelect(e, original)}>
                        {manageIcon.map((item) => {
                          if (item === original.id) {
                            ic = true;
                          } else {
                            ic = false
                          }
                          return ic
                        }
                        )}
                        <Icon icon={original.check ? 'fal fa-check' : 'fal fa-plus'} height={16} />
                      </Button>
                    </CellStart>
                  </Tooltip>
                ),
              }]
              : []
          ),
          ...(
            !rteofile 
              ? [{
                Header: '',
                accessor: 'icon',
                resizable: false,
                width: 60,
                Cell: ({ original }) => (
                  <Tooltip tooltip="copiar link do ficheiro" placement="top">
                    <CellStart>
                      <Button modifiers={['small', 'primaryHover']} onClick={(e) => handleFileUrl(original)}>
                      <Icon icon="fal fa-link" height={16} />
                      </Button>
                    </CellStart>
                  </Tooltip>
                ),
              }] 
              : []

          ),
          {
            Header: intl.formatMessage({ id: 'file.title' }),
            accessor: 'title',
            Cell: ({ value }) => (
              <Cell value={value} loadingDots={loading} />
            ),
          },
          {
            Header: intl.formatMessage({ id: 'file.type' }),
            accessor: 'type',
            Cell: ({ value }) => (
              <Cell loading={loading}>
                <Clamp>
                  <Text modifiers={['light', 'uppercase']}>{value}</Text>
                </Clamp>
              </Cell>
            ),
          },
          {
            Header: intl.formatMessage({ id: 'file.date' }),
            accessor: 'date',
            Cell: ({ value }) => (
              <Cell value={value} loading={loading} />
            ),
          },
          {
            Header: intl.formatMessage({ id: 'file.size' }),
            accessor: 'size',
            Cell: ({ value }) => (
              <Cell value={value} loading={loading} />
            ),
          },
          ...((filemodule && rteofile) ? [
            {
              Header: intl.formatMessage({ id: 'file.numberDownloads' }),
              accessor: 'numberDownloads',
              Cell: ({ value }) => (
                <Cell value={value} loading={loading} />
              ),
            }
          ] 
          : []
          ),
          ...(
            (filemodule && rteofile) 
            ? [
              {
                Header: intl.formatMessage({ id: 'file.lastdownload' }),
                accessor: 'lastDownload',
                Cell: ({ value }) => (
                  <Cell value={value} loading={loading} />
                ),
              }
            ] 
          : []
          ),
          ...(
            (filemodule && rteofile)
              ? [{
                Header: '',
                accessor: 'actions',
                Cell: ({ original }) => (
                  <>
                    <CellEnd>
                      <PopoverActions
                        disabled={loading}
                        actions={[
                          {
                            text: intl.formatMessage({ id: 'file.copy' }),
                            onClick: () => handleCopyToClipboard(original),
                            icon: 'fal fa-link',
                          },
                          {
                            text: intl.formatMessage({ id: 'file.download' }),
                            onClick: () => handleDownload(original),
                            icon: 'fal fa-download',
                          },
                          {
                            text: intl.formatMessage({ id: 'file.edit' }),
                            onClick: () => handleEditFile(original),
                            disabled: isDisable(original),
                          }, {
                            text: intl.formatMessage({ id: 'file.delete' }),
                            onClick: () => setConfirmation({
                              isConfirmed: true,
                              selectedFile: original
                            })
                          }
                        ]}
                        position="bottom"
                        align="start"
                        handlerWidth={72}
                      />
                    </CellEnd>
                  </>
                ),
              }]
              : []
          ),
          /* {
          {
            Header: intl.formatMessage({ id: 'file.numberDownloads' }),
            accessor: 'numberDownloads',
            Cell: ({ value }) => (
              <Cell value={value} loading={loading} />
            ),
          },
          {
            Header: intl.formatMessage({ id: 'file.lastdownload' }),
            accessor: 'lastDownload',
            Cell: ({ value }) => (
              <Cell value={value} loading={loading} />
            ),
          },
          {
            Header: '',
            accessor: 'actions',
            Cell: ({ original }) => (
              <>
                <CellEnd>
                  <PopoverActions
                    disabled={loading}
                    actions={[
                      {
                        text: intl.formatMessage({ id: 'file.copy' }),
                        onClick: () => handleCopyToClipboard(original),
                        icon: 'fal fa-link',
                      },
                      {
                        text: intl.formatMessage({ id: 'file.download' }),
                        onClick: () => handleDownload(original),
                        icon: 'fal fa-download',
                      },
                      {
                        text: intl.formatMessage({ id: 'file.edit' }),
                        onClick: () => handleEditFile(original),
                        disabled: isDisable(original),
                      }, {
                        text: intl.formatMessage({ id: 'file.delete' }),
                        onClick: () => setConfirmation({
                          isConfirmed: true,
                          selectedFile: original
                        })
                      }
                    ]}
                    position="bottom"
                    align="start"
                    handlerWidth={72}
                  />
                </CellEnd>
              </>
            ),
          }, */
        ]}
        minRows={0}
        className="-striped -highlight"
        noDataText={loading ? '' : (noDataText || 'Não foram encontrados ficheiros')}
        sortable={false}
        showPagination={false}
        loading={loading}
        loadingText="A carregar..."
      />

    </>
  )
});

const Cell = ({
  value, loadingDots, loading, children = null
}) => {
  if (loadingDots) return <LoadingDot />
  if (loading) return <LoadingCell />
  if (!value && children === null) {
    return (
      <Text modifiers={['lighter']}>
        <FormattedMessage id="error.missing" />
      </Text>
    )
  }
  if (children !== null) return <>{children}</>
  return (
    <Clamp>
      <Text modifiers={['light']}>{value}</Text>
    </Clamp>
  )
};

const LoadingCell = styled.div`
  width: 80px;
  height: ${props => props.theme.sizes.s};
  background-color: ${props => props.theme.colors.bgLighterS};
`

const CellStart = styled.div`
  width: 100%;
`

const CellEnd = styled.div`
  justify-content: flex-end;
  width: 100%;
  display: flex;
`

FileTable.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string,
      size: PropTypes.oneOfType([PropTypes.number, PropTypes.number]),
      type: PropTypes.string,
      date: PropTypes.string,
      numberDownloads: PropTypes.number,
      lastDownload: PropTypes.string
    })
  ),
  loading: PropTypes.bool,
  intl: intlType.isRequired,
  noDataText: PropTypes.string,
  onSelect: PropTypes.func,
  icon: PropTypes.string,
  subweb: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
};

FileTable.defaultProps = {
  files: [],
  loading: true,
  noDataText: null,
  onSelect: () => { },
  icon: 'fal fa-plus',
}


export default injectIntl(FileTable);
